import { postAccessLogExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityAccessLogExportSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityAccessLogExport',
	receive: true,
	request: true,
	requestHandler: postAccessLogExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
